/**
 * Path prefixes that indicate sales context
 *
 * These paths represent sales pages that do NOT have /kauppa in their
 * site structure nodes, but still are considered sales paths.
 */
export const SALES_PATH_PREFIXES = [
  '/yritysliittymat',
  '/liittymat',
  '/nettiliittymat',
  '/mobiililaajakaista',
  '/netti-pieneen-toimistoon',
  '/netti-isolle-yritykselle',
  '/netin-saatavuus',
  '/laitenetti',
  '/m2m-liittymat',
  '/microsoft-365',
  '/yritystietoturva',
  '/verkkolaiteet',
  '/kassa',
  '/ostoskori',
  '/yhteydenotto',
  '/piilotetut-tarjoukset',
  '/salaiset-tarjoukset',
  '/salaiset-edut',
] as const;
